import React from 'react'
import styled from "styled-components"

import { typeBody02_bold, typeBody02, typeHeading02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { GREY_02 } from '../../theme/colors'

export const Inner = styled.div`
	${props => row({large:true})}
`

export const ContentContainer = styled.div`
	${props => column({large:{span:6},xlarge:{span:5,after:1}},{direction:props.theme.direction})}
	padding-bottom: ${spacer(1)};

	${mediaQuery[SIZE.large]}{
		padding-bottom: 0;
	}
`

export const TableContainer = styled.div`
	${props => column({large:{span:6}},{direction:props.theme.direction})}

	margin-left: ${margin(SIZE.small,{multiplier:-1})};
	margin-right: ${margin(SIZE.small,{multiplier:-1})};

	${mediaQuery[SIZE.medium]}{
		margin-left: 0;
		margin-right: 0;
	}
`

export const Heading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(3)};
`

export const Text = styled.div`
	${typeBody02}
	color: ${props => props.theme.foreground};

	p{
		margin-bottom: ${unit(3)};

		&:last-child{
			margin-bottom: 0;
		}
	}
	
	em{
		background-color: ${props => props.theme.highlight};
	}

	a{
		color: ${props => props.theme.foreground};
		transition: opacity 0.3s;

		&:hover{
			opacity: 0.6;
		}
	}
`

export const Label = styled.p`
	${typeLabel01}
	margin-bottom: ${unit(2)};
	color: ${props => props.theme.alternative};
`

export const TableContent = styled.table`
	width: 100%;
	border-collapse: separate;
	border-spacing: 0 ${unit(1)};
	color: ${props => props.theme.foreground};


`


export const TableColumn = styled.td`
	
`

export const LinkColumn = styled.td`
	width: ${spacer(1)};
`

export const TableRow = styled.tr`
	&:last-child{
		${TableColumn}{
			border-bottom: hidden;
		}
	}
`

export const RowLink = styled.a`
	display: block;
	padding: ${unit(2)} 0;
	text-align: center;
`

export const TableHead = styled.thead`
	${TableColumn}{
		${typeBody02_bold}
		 border-bottom: hidden;
		 padding: ${unit(1)} ${unit(2)};
	}
`

export const TableBody = styled.tbody`
	${TableColumn}{
		${typeBody02}
		padding: ${unit(2)};
	}

	${TableRow}{
		background-color: ${props => props.theme.shadow};
	}
`